import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { CategoryTitle } from '../../pieces/CategoryTitle';
import { Timestamp } from '../../pieces/Timestamp';
import DirectAvatar from '../../pieces/DirectAvatar';
import { DirectAuthor } from '../../pieces/DirectAuthor';

export function DirectHeader({
  title,
  ownerAva,
  ownerId,
  ownerName,
  category,
  createdAt,
}) {
  return (
    <>
      <div className="flex flex-row items-center justify-between">
        <h2 className="text-clip [word-break:break-word]">{title}</h2>
      </div>
      <div className="not-prose mt-2 mb-6 flex flex-row items-center justify-between">
        <div className="flex h-10 items-center gap-2">
          <div className="grid h-10 w-10 place-items-center overflow-hidden rounded-full">
            <DirectAvatar source={ownerAva} altcap={ownerName} />
          </div>
          <div className="flex flex-col">
            <div className="text-clip line-clamp-1">
              <DirectAuthor id={ownerId} name={ownerName} />
            </div>
            <div className="inline-flex items-center gap-1 text-sm opacity-90 sm:text-base">
              <div className="text-clip line-clamp-1">
                <CategoryTitle category={category} />
              </div>
              <div>
                <Icon icon="ci:dot-03-m" />
              </div>
              <Link
                to="."
                className="text-clip line-clamp-1 hover:underline max-[319px]:hidden"
              >
                <Timestamp createdAt={createdAt} />
              </Link>
            </div>
          </div>
        </div>
        <button className="relative inline-block py-2 opacity-30">
          <Icon icon="ph:dots-three-outline-vertical-fill" />
        </button>
      </div>
    </>
  );
}

DirectHeader.propTypes = {
  title: PropTypes.string.isRequired,
  ownerAva: PropTypes.string.isRequired,
  ownerId: PropTypes.string.isRequired,
  ownerName: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
};
